import React, { Component } from 'react';
//import { connect } from 'react-redux';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';

import { PrivateRoute } from './_components';

import Loadable from 'react-loadable';
import './App.scss';

//import Login from './views/Pages/Login';
//import  Page404  from './views/Pages/Page404';
import  DefaultLayout  from './containers/DefaultLayout';


const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
/*const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});*/

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading
});

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading
});

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading
});

class App extends Component {
  render() {
    //console.log('=========App============')
    return (
      <BrowserRouter>
          <Switch>            
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <PrivateRoute path="/" component={DefaultLayout} />
          </Switch>
      </BrowserRouter>      
    );
  }
}

export default App;
//function mapStateToProps(state) {
//  return state;
//}
//export default connect(mapStateToProps)(App) 
